import { render, staticRenderFns } from "./AIPanel.vue?vue&type=template&id=28267f2a&scoped=true"
import script from "./AIPanel.vue?vue&type=script&lang=js"
export * from "./AIPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28267f2a",
  null
  
)

export default component.exports